<template>
    <SingletonDirectusContent :title="$t('imprint.terms')" collection="d_terms_translations"/></template>
<script setup lang="ts">
const route = useRoute();
const platformSettings = usePlatformSettings();
const lang = route.query['lang']

if (lang) {
  platformSettings.setLocale("" + lang);
}

</script>
<style scoped lang="scss">

::v-deep(#content) {
  h2, h3, h4 {
    @apply leading-loose mt-[1em];
  }

  p {
    @apply leading-normal mt-[0.5em];
  }
}

</style>
